module.exports = __webpack_public_path__ + "static/media/shape2_1.35497149.obj";